/* CNOIR Atelier suit page (2026-10-18). Asset file: the store's speed app blocks inline section scripts. */
(function () {
  var root = document.querySelector('[data-cnoir-atelier]');
  if (!root) return;
  var section = root.closest('section, .shopify-section') || document;
  var prices = {}; try { prices = JSON.parse(root.getAttribute('data-prices') || '{}'); } catch (e) {}
  var fmtStr = root.getAttribute('data-money-format') || '£{{amount}}';

  function money(cents) {
    var n = (cents / 100);
    var two = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var none = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmtStr.replace(/\{\{\s*amount_no_decimals\s*\}\}/, none).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, two.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, two);
  }

  // 1. Fabric option: turn the buttons into rows that show each fabric's price.
  function enhanceFabrics() {
    var sets = section.querySelectorAll('variant-selects fieldset, .product-form__input--pill');
    var base = null; Object.keys(prices).forEach(function (k) { if (k !== '_' && prices[k] > 0 && (base === null || prices[k] < base)) base = prices[k]; });
    sets.forEach(function (fs) {
      var lg = fs.querySelector('legend'); if (!lg) return;
      if (lg.textContent.trim().toLowerCase().indexOf('fabric') !== 0) return;
      fs.classList.add('cnoir-atl-fabrics');
      fs.querySelectorAll('input[type=radio]').forEach(function (inp) {
        var lab = fs.querySelector('label[for="' + inp.id + '"]'); if (!lab || lab.querySelector('.atl-p')) return;
        var p = prices[inp.value]; if (!p) return;
        var span = document.createElement('span'); span.className = 'atl-p';
        var diff = p - base;
        span.innerHTML = money(p) + '<small>' + (diff > 0 ? '+' + money(diff) : 'Starting price') + '</small>';
        var name = document.createElement('span'); name.className = 'atl-n';
        while (lab.firstChild && !(lab.firstChild.classList && lab.firstChild.classList.contains('visually-hidden'))) name.appendChild(lab.firstChild);
        lab.insertBefore(name, lab.firstChild); lab.appendChild(span);
      });
    });
  }

  // 2. Measurements: shown openly as a compact panel (still inside the product form, so the order gets every field).
  function foldMeasurements() {
    section.querySelectorAll('.cnoir-mtm').forEach(function (m) {
      if (m.classList.contains('cnoir-atl-mtm')) return;
      m.classList.add('cnoir-atl-mtm');
      var head = document.createElement('div'); head.className = 'cnoir-atl-mtm__head';
      head.innerHTML = '<span class="t">Your measurements</span><span class="o">Optional</span>' +
        '<p class="n">Fill in what you know, or leave it blank and we’ll email you a simple guide after you order. Nothing is cut until we have them.</p>';
      m.insertBefore(head, m.firstChild);
    });
  }

  // 3. Estimated arrival from today's date.
  function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w && w < 6) n--; } return d; }
  function fmt(d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); }
  section.querySelectorAll('[data-cnoir-eta]').forEach(function (el) {
    var max = parseInt(el.getAttribute('data-max') || '14', 10);
    var disp = addBiz(new Date(), max), a = addBiz(disp, 1), b = addBiz(disp, 2);
    var span = el.querySelector('span');
    if (span) span.innerHTML = 'Order today, arrives in the UK around <b>' + fmt(a) + ' – ' + fmt(b) + '</b>. Made to order: dispatched within 10–14 business days.';
  });

  // 4. Sticky buy bar once the real button scrolls out of view. It presses the real button.
  var realBtn = section.querySelector('.product-form__submit');
  if (realBtn && 'IntersectionObserver' in window) {
    var titleEl = section.querySelector('.product__title h1, .product__title .h1');
    var img = section.querySelector('.product__media img');
    var bar = document.createElement('div'); bar.className = 'cnoir-atl-bar'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="cnoir-atl-bar__in">' + (img ? '<img src="' + (img.currentSrc || img.src) + '" alt="">' : '') +
      '<div class="cnoir-atl-bar__info"><b></b><span></span></div><button type="button" tabindex="-1"></button></div>';
    document.body.appendChild(bar);
    bar.querySelector('b').textContent = titleEl ? titleEl.textContent.trim() : document.title;
    var bbtn = bar.querySelector('button');
    function syncBar() {
      var pe = section.querySelector('.price .price-item--last, .price .price-item--regular');
      var picked = Array.prototype.map.call(section.querySelectorAll('variant-selects input[type=radio]:checked, variant-selects select'), function (x) { return x.value; }).join(' · ');
      bar.querySelector('span').textContent = [picked, pe ? pe.textContent.trim() : ''].filter(Boolean).join(' · ');
      var t = realBtn.querySelector('span') ? realBtn.querySelector('span').textContent.trim() : realBtn.textContent.trim();
      bbtn.textContent = t; bbtn.disabled = realBtn.disabled;
    }
    bbtn.addEventListener('click', function () { if (!realBtn.disabled) realBtn.click(); });
    new IntersectionObserver(function (es) { es.forEach(function (e) {
      var on = !e.isIntersecting && e.boundingClientRect.top < 0; bar.classList.toggle('on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); bbtn.tabIndex = on ? 0 : -1;
    }); }).observe(realBtn);
    syncBar();
    new MutationObserver(syncBar).observe(section, { subtree: true, childList: true, characterData: true });
  }


  // 5. "More with your suit" offers: fold into one row so the buy column stays short.
  function foldOffers() {
    section.querySelectorAll('.cnoir-co').forEach(function (co) {
      if (co.closest('.cnoir-atl-more') || co.offsetHeight === 0) return;
      var items = Array.prototype.map.call(co.querySelectorAll('.cnoir-co__item'), function (it) {
        var t = (it.querySelector('h3, h4, strong, b, p') || it).textContent.trim(); return t.split('—')[0].split(' - ')[0].trim();
      }).filter(Boolean).slice(0, 3);
      var d = document.createElement('details'); d.className = 'cnoir-atl-more';
      d.innerHTML = '<summary><span><b>More with your suit</b><small>' + (items.length ? items.join(' · ') : 'Pair it and save') + '</small></span></summary>';
      co.parentNode.insertBefore(d, co); d.appendChild(co);
    });
  }

  enhanceFabrics(); foldMeasurements(); foldOffers();
  var vs = section.querySelector('variant-selects');
  if (vs) new MutationObserver(function () { enhanceFabrics(); }).observe(vs, { childList: true, subtree: true });
})();
